import { api } from "@/services/api"

export interface FeedbackPayload {
  score: 1 | -1
  feedback_text?: string
  conversation_id?: string
  agent_id?: string
  user_input: string
  agent_response: string
  langfuse_trace_id?: string | null
}

export interface FeedbackResponse {
  id: string
  message_id: string
  score: 1 | -1
  feedback_text?: string | null
  created_at: string
}

export const feedbackService = {
  submitFeedback: async (
    messageId: string,
    payload: FeedbackPayload
  ): Promise<FeedbackResponse> => {
    const response = await api.post<FeedbackResponse>(
      `/ai-agent/messages/${messageId}/feedback`,
      payload
    )
    return response.data
  },

  getFeedback: async (messageId: string): Promise<FeedbackResponse | null> => {
    const response = await api.get<FeedbackResponse | null>(
      `/ai-agent/messages/${messageId}/feedback`
    )
    return response.data
  },

  deleteFeedback: async (messageId: string): Promise<void> => {
    await api.delete(`/ai-agent/messages/${messageId}/feedback`)
  },

  getBatchFeedback: async (messageIds: string[]): Promise<FeedbackResponse[]> => {
    const response = await api.post<FeedbackResponse[]>("/ai-agent/messages/feedback/batch", {
      message_ids: messageIds,
    })
    return response.data
  },
}
